import { Sentry } from "@/lib/sentry";

let installed = false;

/**
 * Install global listeners for unhandled errors and promise rejections so
 * they are forwarded to Sentry. Silent to the user — purely for telemetry.
 */
export function installGlobalErrorHandlers() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  window.addEventListener("unhandledrejection", (event) => {
    try {
      const reason = event.reason;
      const msg = reason instanceof Error ? reason.message : String(reason);
      // Supabase auth Web Locks contention — unactionable, 0 users. Don't capture.
      if (msg.includes("LockManager lock") && msg.includes("immediately failed")) {
        return;
      }
      Sentry.captureException(reason instanceof Error ? reason : new Error(String(reason)), {
        tags: { source: "unhandledrejection" },
      });
    } catch {
      // Never throw from the handler.
    }
  });

  window.addEventListener("error", (event) => {
    try {
      const err = event.error ?? new Error(event.message || "window.onerror");
      Sentry.captureException(err, { tags: { source: "window.onerror" } });
    } catch {
      // Never throw from the handler.
    }
  });
}
